<template>
  <div class="feedback-box">
    <div class="feedback-title">问题类型</div>
    <div class="feedback-nav">
      <div class="nav-li" :class="{ active: activeIndex === index }" @click="selectType(index, item)" v-for="(item, index) in navList" :key="index">{{ item.name }}</div>
    </div>
    <div class="feedback-title">反馈内容</div>
    <div class="feedback-text">
      <el-input type="textarea" placeholder="请详细说明，以便于我们解决问题,您最多可以填写150字。" v-model="content" maxlength="150" show-word-limit>
      </el-input>
    </div>
    <div class="feedback-title">联系方式</div>
    <div class="feedback-input">
      <el-input v-model="contact" placeholder="请输入您的手机号或邮箱（以便我们及时反馈）" />
    </div>
    <el-button class="bt" @click="onClickSubmit">提交</el-button>
  </div>
</template>

<script>
import { addFeedback } from '@/api/home'
export default {
  name: "index",
  data() {
    return {
      navList: [
        {
          name: '功能建议',
          value: 'FUNCTION_ADVISE',
        },
        {
          name: '投诉意见',
          value: 'COMPLAINT_OPINIONS',
        },
        {
          name: '其他反馈',
          value: 'OTHER',
        },
      ],
      activeIndex: 0, // 默认第一个为选中项
      content: '',
      contact: '',
      selectedType: 'FUNCTION_ADVISE',
      userinfo: {}
    }
  },
  methods: {
    selectType(index, item) {
      this.activeIndex = index
      this.selectedType = item.value
    },
    onClickSubmit() {
      if(this.content == "") {
        this.$message.warning('请输入反馈内容')
        return
      }
      if(this.contact == "") {
        this.$message.warning('请输入联系方式')
        return
      }
      addFeedback({
        contact: this.contact,
        content: this.content,
        userId: this.userinfo.id,
        type: this.selectedType,
      }).then(res => {
        if(res.code == "A00000") {
          this.contact = ""
          this.content = ""
          this.$message.success('提交成功')
        }else {
          this.$message.error(res.message)
        }
      })
    },
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem('userInfo'))
  }
}
</script>

<style scoped lang="less">
.feedback-box {
  padding: 34px 24px;
  text-align: left;

  /deep/.el-textarea .el-input__count {
    background: #F5F5F5;
  }

  /deep/.el-textarea__inner {
    background: #F5F5F5;
    font-size: 14px;
    line-height: 22px;
    height: 100px;
    border: none;
  }

  /deep/.el-input__inner {
    background: #F5F5F5;
    font-size: 14px;
    height: 46px;
    border: none !important;
  }

  .feedback-nav {
    display: flex;
    align-items: center;

    .nav-li.active {
      background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
      color: #fff;
    }

    .nav-li {
      background: #F5F5F5;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 16px;
      color: #737373;
      font-size: 14px;
      border-radius: 50px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .feedback-title:first-child {
    margin-top: 0;
    margin-bottom: 20px;
  }

  .bt {
    background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
    color: #fff;
    font-size: 16px;
    height: 44px;
    border-radius: 6px;
    width: 255px;
    border: none;
    display: block;
    margin: auto;
    margin-top: 330px;
  }

  .feedback-title {
    color: #262626;
    font-size: 15px;
    line-height: 15px;
    margin-bottom: 12.5px;
    margin-top: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/Feedback.vue